<template>
  <el-dialog
    title="上传合同"
    :visible.sync="visible"
    width="1000px"
    :close-on-click-modal="false"
    top="5vh"
    @opened="onOpened"
    class="dialog-Individuation"
  >
    <el-form label-suffix=":" label-width="200px" :model="form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="公告标题">
            <span>{{ formself.title }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公告编号">
            <span>{{ formself.code }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="处置方式">
            <span>{{
              formself.disposalCode === '1' ? '竞价' : '密封报价'
            }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formself.disposalCode == '2'">
          <el-form-item label="报价方式">
            <span>{{
              formself.bidCodeMate === '10' ? '整体报价' : '按物资分项报价'
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="成交价(元)">
            <span v-if="formself.dealPrice">{{
              formself.dealPrice | numberFormat(2)
            }}</span>
            <span v-else>--</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成交总金额(元)">
            <span>{{ formself.dealTotalPrice | numberFormat(2) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="成交日期">
            <span>{{ formself.dealTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买受人">
            <span>{{ formself.buyerCompName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">合同等资料</el-divider>

      <on-Upload
        :checkFlag="checkFlag"
        :fileList="formself.orderFileList"
        @fileDataSingle="val => onFileDataSingle(val, 'orderFileList')"
        labelWidth="200px"
        labelName="合同"
      ></on-Upload>
      <on-Upload
        :checkFlag="checkFlag"
        accept=".avi,wmv,.mpeg,.mp4,.mov,.mkv,.flv,.rmv"
        :fileList="formself.orderSendVideoFileList"
        @fileDataSingle="onVideoDataSingle"
        labelWidth="200px"
        labelName="发货视频"
      ></on-Upload>
      <on-Upload
        :checkFlag="checkFlag"
        :fileList="formself.orderInvoiceFileList"
        @fileDataSingle="val => onFileDataSingle(val, 'orderInvoiceFileList')"
        labelWidth="200px"
        labelName="发票"
      ></on-Upload>
      <el-form-item label="说明">
        <el-input
          v-if="!checkFlag"
          style="width:80%"
          type="textarea"
          v-model="formself.remark"
          placeholder="请输入说明"
          maxlength="400"
          show-word-limit
        ></el-input>
        <span v-else>{{ formself.remark }}</span>
      </el-form-item>
      <on-Upload
        :checkFlag="checkFlag"
        :fileList="formself.orderOtherFileList"
        @fileDataSingle="val => onFileDataSingle(val, 'orderOtherFileList')"
        labelWidth="200px"
        labelName="其他附件"
      ></on-Upload>
    </el-form>
    <span slot="footer">
      <el-button
        @click="submit(1)"
        type="primary"
        v-if="!checkFlag"
        :loading="loading"
        >提交</el-button
      >
      <el-button
        @click="submit(0)"
        type="primary"
        v-if="!checkFlag"
        :loading="loading"
        >保存</el-button
      >
      <el-button @click="onCancel" v-if="!checkFlag" :loading="loading"
        >取消</el-button
      >
      <el-button @click="onCancel" v-else>关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ReconnaissanceDialog',
  props: {
    clickRow: Object,
    show: Boolean,
    viewFlag: Boolean
  },
  components: {},
  data() {
    return {
      form: {},
      formself: {
        orderFileList: [],

        orderSendVideoFileList: [],
        orderOtherFileList: [],
        orderInvoiceFileList: [],
        remark: ''
      },
      loading: false,
      active: 0,
      tableData: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(v) {
        this.$emit('update:show', v)
      }
    },
    checkFlag() {
      return this.clickRow.orderDataStatus == 1
    }
  },

  methods: {
    async onOpened() {
      let data = await this.$api.serviceProvider.getOrderData({
        noticeId: this.clickRow.id
      })
      console.log(data)
      this.formself = {
        ...data,
        orderFileList: data.orderFileList || [],
        orderSendVideoFileList: data.orderSendVideoFileList || [],
        orderOtherFileList: data.orderOtherFileList || [],
        orderInvoiceFileList: data.orderInvoiceFileList || []
      }
      if (
        this.formself.orderSendVideoFileList &&
        this.formself.orderSendVideoFileList.length != 0
      ) {
        this.formself.orderSendVideoFileList.map(item => {
          item.name = item.fileName
        })
      }
    },
    onFileDataSingle(val, name) {
      this.formself[name] = val
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    async submit(type) {
      if (
        (!this.formself.orderFileList ||
          this.formself.orderFileList.length == 0) &&
        (!this.formself.orderInvoiceFileList ||
          this.formself.orderInvoiceFileList.length == 0) &&
        (!this.formself.orderOtherFileList ||
          this.formself.orderOtherFileList.length == 0) &&
        (!this.formself.orderSendVideoFileList ||
          this.formself.orderSendVideoFileList.length == 0) &&
        !this.formself.remark
      ) {
        this.$message.error('请至少添加一项')
      } else {
        let params = {
          id: this.formself.id,
          noticeId: this.clickRow.id,
          status: type,
          orderFileList: this.formself.orderFileList,
          orderInvoiceFileList: this.formself.orderInvoiceFileList,
          orderOtherFileList: this.formself.orderOtherFileList,
          orderSendVideoFileList: this.formself.orderSendVideoFileList,
          remark: this.formself.remark
        }
        this.loading = true
        let data = await this.$api.serviceProvider.saveOrderData(params)
        this.loading = false
        if (data) {
          this.onCancel()
          this.$message.success('提交成功')
          this.$emit('success', true)
        }
      }
    },
    onVideoDataSingle(val) {
      this.formself.surveyVideoFileList = val
    },
    onCancel() {
      this.$emit('update:show', false)
      this.formself = {
        orderFileList: [],
        orderInvoiceFileList: [],
        orderOtherFileList: [],
        orderSendVideoFileList: [],
        remark: ''
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
